// eslint-disable-next-line no-unused-vars
import { baseURL } from '../config/index'
import { post, get, put, upload, remove } from './config'

export const uploadURL = baseURL + '/api/v1/upload'

/**
 * 上传文件
 * @param {*} data
 */
export const uploadFile = (data) => upload(`/api/v1/upload`, data)

/**
 * 登录
 * @param {*} data
 */
export const login = (data) => post(`/admin/api/v1/auth/login`, data)

/**
 * 退出登录
 * @param {*} data
 */
export const logout = (data) => get(`/api/v1/user/signout`, data)

/**
 * 获取当前账号的信息
 * @param {} data
 */
export const getUserInfo = (data) => get(`/admin/api/v1/user/info`, data)

/**
 * 获取系统内账号列表
 * @param {*} data
 */
export const getAdminList = (data) => get(`/admin/api/v1/account/list`, data)

/**
 * 添加系统账号
 * @param {*} data
 */
export const createAdmin = (data) => post(`/admin/api/v1/account/add`, data)

/**
 * 启用或禁用账号
 * @param {*} data
 */
export const updateAdminStatus = (accountId, data) => put(`/admin/api/v1/account/${accountId}/status`, data)

/**
 * 获取用户列表
 * @param {*} data
 */
export const getUserList = (data) => get(`/admin/api/v1/user/list`, data)

/**
 * 获取导出用户时需要的数据
 * @param {*} data
 */
export const getAllUserData = (data) => get(`/admin/api/v1/user/export`, data)

/**
 * 获取被评论的期刊列表
 * @param {*} data
 */
export const getJournalList = (data) => get(`/admin/api/v1/journal/list`, data)

/**
 * 获取期刊中的评论列表
 * @param {*} journalId
 * @param {*} data
 */
export const getCommentListByJournalId = (journalId, data) => get(`/admin/api/v1/journal/${journalId}/comment/list`, data)

/**
 * 更改评论的状态，通过/不通过
 * @param {*} journalId
 * @param {*} commentId
 * @param {*} data
 */
export const updateCommentStatus = (journalId, commentId, data) => put(`/admin/api/v1/journal/${journalId}/comment/${commentId}/status`, data)

/**
 * 更新评论的置顶状态
 * @param {*} journalId
 * @param {*} commentId
 * @param {*} data
 */
export const updateCommentStickieStatus = (journalId, commentId, data) => put(`/admin/api/v1/journal/${journalId}/comment/${commentId}/stickie`, data)

/**
 * 删除评论
 * @param {*} journalId
 * @param {*} commentId
 * @param {*} data
 */
export const deleteCommentStatus = (journalId, commentId, data) => remove(`/admin/api/v1/journal/${journalId}/comment/${commentId}`, data)

/**
 * 获取优惠券列表
 * @param {*} data
 */
export const getCouponList = (data) => get(`/admin/api/v1/coupon/list`, data)

/**
 * 获取优惠卷类型列表
 * @param {*} data
 */
export const getCouponTypeList = () => get(`/admin/api/v1/coupon/service/list`)

/**
 * 新增优惠券
 * @param {*} data
 */
export const addCoupon = (data) => post(`/admin/api/v1/coupon`, data)

/**
 * 更改优惠券上下架状态
 * @param {*} id
 * @param {*} data
 */
export const updateCouponStatus = (id, data) => put(`/admin/api/v1/coupon/${id}/status`, data)

/**
 * 获取优惠券券码领取列表
 * @param {*} id
 * @param {*} data
 */
export const getCouponReceivedList = (id, data) => get(`/admin/api/v1/coupon/${id}/code`, data)

/**
 * 更改领取券码的使用状态
 * @param {*} id
 * @param {*} data
 */
export const updateCouponCodeStatus = (id, data) => put(`/admin/api/v1/coupon/code/${id}/status`, data)

/**
 * 获取轮播图列表
 */
export const getBannerList = () => get(`/admin/api/v1/banner/list`)

/**
 * 保存轮播图列表
 * @param {*} data
 */
export const updateBannerList = (data) => put(`/admin/api/v1/banner/update`, data)

/**
 * 获取学科分类下拉列表
 * @param {*} data
 */
export const getSubjectList = (data) => get(`/admin/api/v1/category/down`, data)

/**
 * 获取期刊排名列表
 * @param {*} data
 */
export const getJournalRankList = (data) => get(`/admin/api/v1/journal/ranking`, data)

/**
 * 获取导出期刊排名的数据
 * @param {*} data
 */
export const getJournalRankExportData = (data) => get(`/admin/api/v1/journal/export`, data)

/**
 * 获取网站内容列表
 * type: 11:期刊推荐, 12:实施收录, 13:cfp, 21:公告, 22:本站特色, 23:本站使用指南
 * @param {*} data
 */
export const getWebContentList = (data) => get(`/admin/api/v1/web_content/list`, data)

/**
 * 新增网站内容
 * @param {*} data
 */
export const createWebContentItem = (data) => post(`/admin/api/v1/web_content`, data)

/**
 * 编辑网站内容
 * @param {*} id
 * @param {*} data
 */
export const editWebContentItem = (id, data) => put(`/admin/api/v1/web_content/${id}`, data)

/**
 * 删除网站内容
 * @param {*} id
 * @param {*} data
 */
export const deleteWebContentItem = (id, data) => remove(`/admin/api/v1/web_content/${id}`, data)

/**
 * 获取网站内容详情
 * @param {*} id
 * @param {*} data
 */
export const getWebContentItemDetail = (id, data) => get(`/api/v1/web_content/${id}`, data)

// 首页轮播图管理添加
export const addCarouselInfo = (data) => post(`/api/v1/admin/carouselinfo/add`, data, 'java')
// 首页轮播图管理更新
export const updateCarouselInfo = (data) => post(`/api/v1/admin/carouselinfo/update`, data, 'java')
// 首页轮播图管理删除
export const deleteCarouselInfo = (data) => post(`/api/v1/admin/carouselinfo/delete`, data, 'java')
// 首页轮播图管理查询列表
export const listCarouselInfo = (data) => get(`/api/v1/admin/carouselinfo/list`, data, 'java')
// 首页轮播图管理查询详情
export const detailCarouselInfo = (data) => get(`/api/v1/admin/carouselinfo/detail`, data, 'java')



// WEBPACK FOOTER //
// ./src/api/index.js